import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async getNotificationByID(store, notificationID) {
    const { commit } = store;
    return await axios({
      url: `/v1/notifications/${notificationID}?include=event,project,control_point,control_point_request`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setNotification', resp.data.data);
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async deleteNotification(store, { eventID, notificationID }) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/events/${eventID}/notifications/${notificationID}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('dashboard/updateContext', null, { root:true });
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
};

export default actions;